import {
  colorTokenMap,
  GDSColorToken,
  GDSComposableCardBackgroundColor,
  GDSBackgroundColor,
} from '@leagueplatform/genesis-core';

const isHexColor = (value: string): boolean =>
  /^#([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(value);

const isGDSBackgroundColor = (value: string): value is GDSBackgroundColor =>
  value === 'primary' || value === 'secondary' || value === 'tertiary';

export const resolveBackgroundColorValue = (
  color?: GDSComposableCardBackgroundColor,
): GDSComposableCardBackgroundColor | undefined => {
  if (!color) return color;
  if (typeof color === 'string' && isGDSBackgroundColor(color)) return color;
  if (typeof color === 'string') {
    if (color.startsWith('$') || isHexColor(color)) return color;
    const tokenName = color as unknown as GDSColorToken;
    const mapped = colorTokenMap[tokenName as keyof typeof colorTokenMap];
    if (mapped) {
      return mapped as GDSComposableCardBackgroundColor;
    }
  }
  return color;
};
